import React, { useState } from 'react';
import { Project } from '../types';
import { Link, useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import styled from 'styled-components';
import { FaGithub, FaHome } from "react-icons/fa";
import { uploadMenuPdf } from '../../Util/api';
import { useDispatch } from 'react-redux';
import { setBlock } from '../../../modules';

const webProjectsData: Project[] = [
  { title: '내일의 모든 것', description: '네이버 날씨 및 운세 크롤링', gitLink: '#', projectLink: '/tomorrow', imgSrc: '/images/tomorrow_img.png' },
  { title: 'Good Record', description: '노래 녹음 정리 플랫폼', gitLink: '#', projectLink: '/goodrecord' , imgSrc: '/images/goodrecord_img.png'},
  { title: '카톡뷰', description: '카카오톡 대화 데이터 정규화', gitLink: '#', projectLink: '/katalkview', imgSrc: 'images/katalkview_img.png' },
  { title: '구내식당 메뉴 가져오기', description: '메일 크롤링', projectLink: '/util', imgSrc: 'images/restaurant_img.jpg', isUtil: true },
];

const gameProjectsData: Project[] = [
  { title: 'Project 1', description: '현재 개발중', gitLink: '#', projectLink: '/', imgSrc: 'images/game-example.jpg' },
  { title: 'Project 2', description: '현재 개발중', gitLink: '#', projectLink: '/', imgSrc: 'images/game-example.jpg' },
  // { title: 'Project 3', description: '현재 개발중', gitLink: '#', projectLink: '/', imgSrc: 'images/game-example.jpg' },
  // { title: 'Project 4', description: '현재 개발중', gitLink: '#', projectLink: '/', imgSrc: 'images/game-example.jpg' },
];

const Thumbnail = styled.img`
  margin-top: 8px;
  border-radius: 8px;
`;
const MenuFilename = styled.p`
  font-size: 0.7rem;
`;
const ProjectBoxStyle = styled.div`
  max-width: 420px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
interface ProjectProps {
  idx: number,
  project: Project,
  user: string
}
const ProjectBox: React.FC<ProjectProps> = ({idx, project, user}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const chkUser = (): boolean => {
    if(user) return false;
    dispatch(setBlock(true));
    return true;
  }
  const onClick = (to: string) => {
    if(chkUser()) return;
    navigate(to);
  }
  const [filename ,setFilename] = useState("");
  return (
    <ProjectBoxStyle>
      <div key={idx} className="project-card" data-project={idx}>
        <Thumbnail 
          src={
              project.imgSrc 
              ? `${process.env.PUBLIC_URL}${project.imgSrc}` 
              : 'https://picsum.photos/300/200'} 
          alt="proejct image" 
          width={240} height={160} />
        <h3>{project.title}</h3>
        {/* <p>{project.description}</p> */}
        {filename !== "" && <MenuFilename id='menu-filename'>{filename}</MenuFilename>}
        {
          !project.isUtil 
          ? <button className='detail-btn'><Link to={`/detail${project.projectLink}`}>Detail</Link></button>
          : <button className='detail-btn' onClick={() => {
            if(chkUser()) return;
            setFilename('Loading...')
            uploadMenuPdf()
            .then((response: any) => {
              console.log(response.response);
              setFilename(response.response.data.filename)
            })
            .catch((error) => setFilename('Error'));
          }}>Execute</button>
        }
        {project.gitLink && <Link to={project.gitLink} className="git-btn"><FaGithub size="20px" /></Link>}
        {!project.isUtil  && project.projectLink && <div onClick={() => onClick(project.projectLink as string)} className="home-btn"><FaHome size="20px" /></div>}
      </div>
    </ProjectBoxStyle>
  );
}

const Projects: React.FC = () => {
  // eslint-disable-next-line
  const [cookie, setCookie, removeCookie] = useCookies(['user']);
  const user = cookie.user || ""; // user를 문자열로 설정
  return (
    <section id="projects" className="projects">
      <h2>Web & Util Projects</h2>
      <div className="project-grid">
        {webProjectsData.map((project, idx) => (
          <ProjectBox key={idx} idx={idx} project={project} user={user} />
        ))}
      </div>
      <h2>Game Projects</h2>
      <div className="project-grid">
        {gameProjectsData.map((project, idx) => (
          <ProjectBox key={idx} idx={idx} project={project} user={user} />
        ))}
      </div>
    </section>
  );
};

export default Projects;